import {
  ASSESSMENT_WITH_DIFFERENTIATION_DOCUMENT,
  SELF_ASSESSMENT_DOCUMENT,
} from 'global/constants';

export function canDisableBookmark({
  canBookmark,
  canSeePublishedActivities,
  isBookmarked,
  documentType,
  isAssessment,
}: {
  canBookmark: boolean;
  canSeePublishedActivities: boolean;
  isBookmarked: boolean;
  documentType: string | undefined;
  isAssessment: boolean;
}) {
  return !!(
    (
      canBookmark &&
      canSeePublishedActivities &&
      !isBookmarked &&
      (isAssessment
        ? documentType === ASSESSMENT_WITH_DIFFERENTIATION_DOCUMENT ||
          documentType === SELF_ASSESSMENT_DOCUMENT
        : documentType === undefined)
    ) // lesson worksheets don't have a document type
  );
}
